import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_MERCHANT_SETTINGS_ROUTE_NAME = Symbol('admin.merchant-settings');
export const ADMIN_MERCHANT_SETTINGS_LIST_ROUTE_NAME = Symbol('admin.merchant-settings.list');

export const TRANSLATION_GROUP_MERCHANT_SETTINGS = Symbol('admin.merchant-settings');

export const MERCHANT_SETTINGS_LIST_QUERY_KEY = 'admin.merchant-settings.list';
export const MERCHANT_SETTINGS_LIST_API_URL = 'admin/merchants/list';

export const MERCHANT_SETTINGS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.MERCHANT_SETTINGS_SHOW),
  EDIT: new Permission(PermissionsList.admin.MERCHANT_SETTINGS_EDIT),
};
